function HeaderTitle(props) {
	const { automationClass = '', dataAt = '' } = props;
	return (
		<h1 className={`page-head__title ${automationClass}`} data-at={dataAt}>
			{props.children}
		</h1>
	);
}
export default HeaderTitle;
